import { Injectable } from "@angular/core";
import { AbstractControl, UntypedFormGroup, Validators } from "@angular/forms";

@Injectable({ providedIn: 'root' })
export class ClaimCustomerValidator {
    removeRequiredValidators(fields: AbstractControl<any, any>[]) {
        fields.forEach(field => {
            this.removeRequiredValidator(field);
        });
    }
    removeRequiredValidator(field: AbstractControl<any, any>) {
        if (field) {
            field.removeValidators(Validators.required);
            field.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }
    }
    addRequiredValidators(fields: AbstractControl<any, any>[]) {
        fields.forEach(field => {
            this.addRequiredValidator(field);
        });
    }
    addRequiredValidator(field: AbstractControl<any, any>) {
        if (field) {
            field.addValidators(Validators.required);
            field.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }
    }
    setFieldErrors(field: AbstractControl<any, any>, arg1: { required: boolean; }) {
        if (field) {
            field.setErrors(arg1);
        }
    }
}